export type ChannelConsentState =
  | 'SUBSCRIBED'
  | 'UNSUBSCRIBED'
  | 'PENDING'
  | 'NOT_SUBSCRIBED';

export interface ChannelConsent {
  state: ChannelConsentState;
  updatedAt: string;
}

export interface Subscriber {
  id: string;
  email: string;
  emailChannel: ChannelConsent;
  smsChannel: ChannelConsent;
  preferenceFormToken: string;
}

export interface PreferenceFormPreferences {
  emailChannel: ChannelConsentState;
  smsChannel: ChannelConsentState;
  consentLanguage?: string | null;
}

export interface PreferenceFormSubmission {
  preferenceFormToken: string;
  emailChannel?: ChannelConsentState | null;
  smsChannel?: ChannelConsentState | null;
  ipAddress?: string | null;
  userAgent?: string | null;
  urlLocation?: string | null;
}

export const PREFERENCE_FORM_CHANNEL_OPTIONS: {
  value: ChannelConsentState;
  label: string;
  description: string;
}[] = [
  {
    value: 'SUBSCRIBED',
    label: 'Subscribed',
    description: 'Send marketing messages on this channel',
  },
  {
    value: 'UNSUBSCRIBED',
    label: 'Unsubscribed',
    description: 'Do not send marketing messages on this channel',
  },
];
